import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Note } from './note'

export class NotesRepository extends BaseRepository<Note> {
    constructor(
        personId: string,
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/persons/' + personId + '/notes', token, cache)
    }
}
